import { AcademicZoneEnum } from '../../enums/staff/academic-zone.enum'
import { PeriodTypes } from '../period/period'
import { Journey } from './journey'
import { Product, ProductLight, ProductPartial } from './product'

export interface ProductDate {
  id: number
  createdAt: Date
  updatedAt: Date

  durationInDays: number
  locked: boolean

  product: Product
  productId: number

  period: PeriodTypes.Full
  periodId: number
  academicZones: AcademicZoneEnum[]

  departureDate: string
  returnDate: string
  basePrice: number

  journeys: Journey[]
}

export interface ProductDatesFilter {
  productId?: number
  years?: number[]
  periods?: string[]
  options?: string[]
  mainOptions?: string[]
  tripIds?: number[]
  journeyPlaces?: string[]
  durationInDays?: number
  locked?: boolean
  published?: boolean
}

export interface DatesDurationInput {
  departureDate: string
  returnDate: string
}

export class ProductDateProperties {
  static getColor(productDate: ProductDateLight): string {
    return productDate.period?.color ?? '#3D3D3D'
  }
}

export type ProductDateLight = Pick<
  ProductDate,
  'id' | 'departureDate' | 'returnDate' | 'durationInDays' | 'locked' | 'basePrice'
> & {
  period: PeriodTypes.Basic
  product: ProductLight
}

export type ProductDatePartial = Pick<ProductDate, 'id' | 'departureDate' | 'returnDate'> & {
  period: PeriodTypes.Basic
  product: ProductPartial
}

export type ProductDateBasic = Pick<ProductDate, 'id' | 'departureDate' | 'returnDate'>
export type ProductDateStandard = Pick<ProductDate, 'id' | 'departureDate' | 'returnDate'> & {
  period: PeriodTypes.Basic
}
